import { toRRuleScheduleItem } from "../../../components/RRule/FormikRRuleSchedule.js";
import { RRuleTag } from "../../../components/RRule/RRuleTag.js";
import { DayTimelineRangeDisplay } from "../../../components/RRule/DayTimelineRangeDisplay.js";
import { LocationAndGroupNames } from "../../Locations/shared/LocationAndGroupNames.js";
import "react";
import { Button, Card, Icon } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdEdit } from "react-icons/md";
//#region src/modules/ServicePeriods/location-panel/ServicePeriodScheduleCard.tsx
function ServicePeriodScheduleCard({ locationId, onEdit, period }) {
	const schedule = toRRuleScheduleItem(period.schedule);
	const assignedToId = period.assignment.assignedToId;
	const showAssignment = Boolean(assignedToId && assignedToId !== locationId);
	return /* @__PURE__ */ jsxs(Card, {
		borderColor: "neutral",
		borderLeft: "md",
		padding: "sm",
		space: "xs",
		children: [
			/* @__PURE__ */ jsxs("div", {
				className: "gap-xs flex items-start justify-between",
				children: [/* @__PURE__ */ jsx("div", {
					className: "text-color-strong font-bold",
					children: period.name
				}), onEdit && /* @__PURE__ */ jsx(Button, {
					onClick: () => onEdit(period.id),
					size: "xs",
					subtle: true,
					children: /* @__PURE__ */ jsx(Icon, {
						Icon: MdEdit,
						size: "sm"
					})
				})]
			}),
			period.description && /* @__PURE__ */ jsx("div", {
				className: "text-color-subtle text-sm",
				children: period.description
			}),
			schedule.rrule && /* @__PURE__ */ jsxs("div", {
				className: "gap-xxs flex flex-col",
				children: [/* @__PURE__ */ jsx(RRuleTag, {
					durationMin: schedule.durationMin,
					rruleString: schedule.rrule
				}), /* @__PURE__ */ jsx(DayTimelineRangeDisplay, {
					durationMin: schedule.durationMin,
					rrule: schedule.rrule
				})]
			}),
			showAssignment && assignedToId && /* @__PURE__ */ jsx("div", {
				className: "text-color-subtle text-sm",
				children: /* @__PURE__ */ jsx(LocationAndGroupNames, { locationAndGroupIds: [assignedToId] })
			})
		]
	});
}
//#endregion
export { ServicePeriodScheduleCard };

//# sourceMappingURL=ServicePeriodScheduleCard.js.map